module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","forms"],"commonjs":"@angular/forms","commonjs2":"@angular/forms","amd":"@angular/forms"}
// module id = 2
// module chunks = 0 1